import type { Position } from 'geojson';
import type * as mapboxgl from 'mapbox-gl';

export function isEventAtCoordinates(event: mapboxgl.MapMouseEvent, coordinates: Position) {
  if (!event.lngLat) return false;
  return event.lngLat.lng === coordinates[0] && event.lngLat.lat === coordinates[1];
}
